// 引入二次封装
import request from "@/utils/request.js";

// // 导出get请求的接口方法
// export function myget(params) {
//   return request({
//     url: "xxx",
//     method: "get",
//     params,
//   });
// }

// // 导出post请求的接口方法
// export function mypost(data) {
//   return request({
//     url: "xxx",
//     method: "post",
//     data,
//   });
// }



// 获取我的下载列表
export function userDownloadList(token,data) {
  return request({
    url: "/api/user/download_list",
    method: "post",
    data,
    headers:{ token }
  });
}


// 删除下载列表
export function delDownloadList(token,data) {
  return request({
    url: "/api/user/download_del",
    method: "post",
    data,
    headers:{ token }
  });
}



// 下载列表重新下载
export function userDownloadUrl(data) {
  return request({
    url: "/api/user/download_url",
    method: "post",
    data,
  });
}

